// extracted by mini-css-extract-plugin
export default {"root":"styles_root__eUMC-","thumbnail":"styles_thumbnail__7zTM8"};